import React, { FC } from 'react';

import { baseBlue, white } from '~src/styles/colors';

import LLsLoader from './LLsLoader';

interface Props {
  color?: string;
  secondColor?: string;
}

const PageLoader: FC<Props> = React.memo(({ color = white.a10, secondColor = baseBlue.a10 }) => (
  <div className="app-init-spinner spinner">
    <LLsLoader color={color} secondColor={secondColor} />
  </div>
));

export default PageLoader;
